/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactWorkflowRole = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 7a5 5 0 1 1 10 0A5 5 0 0 1 5 7zm.32 10.476C4.435 18.328 4 19.541 4 21v1H2v-1c0-1.857.564-3.644 1.93-4.963C5.296 14.72 7.327 14 10 14h1v2h-1c-2.326 0-3.795.622-4.68 1.476zM18.586 12l-.793-.793 1.414-1.414L22.414 13l-3.207 3.207-1.414-1.414.793-.793H15v5h1.17a3.001 3.001 0 1 1 0 2H13v-9zM18 20a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactWorkflowRole as ContactWorkflowRole };
